import { careerProfilePathFromLatest, rewriteExperienceIndexPath } from "../career-profile/careerPlanLatest";

export function careerProfilePathFromLegacy(pathname: string, search = ""): string {
  const rewritten = pathname.replace("/career-plan", "/career-profile");
  const match = rewritten.match(/^\/people\/([^/]+)\/career\/career-profile\/latest\/?$/);
  if (match) {
    return careerProfilePathFromLatest(match[1], search);
  }
  return rewriteExperienceIndexPath(rewritten, search) ?? `${rewritten}${search}`;
}
